import http from 'conversations-http/clients/http';
export const fullCommonMessageClient = ({
  threadId,
  messageId
}) => {
  return http.get(`conversations-threads/v1/message/${threadId}/${messageId}`);
};